module.exports = __webpack_public_path__ + "static/media/footer.05d7719a.png";